import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-sales-team-view',
  templateUrl: './sales-team-view.component.html',
  styleUrls: ['./sales-team-view.component.css']
})
export class SalesTeamViewComponent implements OnInit {

  constructor(private brandService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[]; //---store get() result--------
  TeamId='';
  //getUrl='http://192.241.151.66:5000/viewBrands';
  imgUrl=this.brandService.ReturnBase();
  name=""

  //------routing to edit page--------------------
   EditItem(){
    this.router.navigateByUrl(('admin/sales-team-edit'));  
  }
  
  //--------function which give id of selected customer---------
  getValue(){
    this.brandService.setSalesTeamId(this.TeamId)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  //-------date formating-------------
  
today: Date = new Date();
pipe = new DatePipe('en-US');
todayWithPipe:any= null;

DateFormat(value:any){
  //-------date formating----------------------
  this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
  let myString= this.todayWithPipe
  myString = myString.substr(0, myString.length - 12);
  return myString
}

DateFormat1(value:any){
  //-------date formating----------------------
  this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
 
  return this.todayWithPipe
}
  ngOnInit(): void {

        //---call function in service for brand Id------
        this.TeamId=this.brandService.getSalesTeamId()
       
       //-------api get()calling-------------
       this.brandService.ViewTeamById('/'+this.TeamId).subscribe((res)=>{
       this.output=res.data
       this.name=this.output[0].department_name
    

        
       })
  }

}
